<div class="w-100 d-flex align-items-center flex-row flex-wrap justify-content-end asset-action-btn-wrapper">
    <button type="submit" class="common-button medium black mat-elevation-z0 rounded-corners me-1 mb-1 no-min-width" mat-button mat-raised-button (click)="edit()" [disabled]="isLoading">
        Edit
    </button>
    <button *ngIf="assetStatus != assetStatusCategories[assetStatusCategories.SentToTenant]" class="common-button medium success mat-elevation-z0 rounded-corners me-1 mb-1 no-min-width" mat-button mat-raised-button (click)="approve()" [disabled]="isLoading"
    [class.spinner]="isLoading">
        Approve
    </button>
    <button *ngIf="assetStatus == assetStatusCategories[assetStatusCategories.SentToTenant]" class="common-button medium success mat-elevation-z0 rounded-corners me-1 mb-1 no-min-width" mat-button mat-raised-button (click)="approve()" [disabled]="isLoading"
    [class.spinner]="isLoading">
        Override & Approve
    </button>
    <button class="common-button medium red mat-elevation-z0 rounded-corners me-1 mb-1 no-min-width" mat-button mat-raised-button (click)="delete()" [disabled]="isLoading">
        Delete
    </button>
    <button *ngIf="isShowSendToTenant && !asset?.isOnceSendToTenantAsset" class="common-button medium black mat-elevation-z0 rounded-corners me-1 mb-1 no-min-width" mat-button mat-raised-button (click)="openDrawer(asset.id)" [disabled]="isLoading">
        Send to Tenant
    </button>
    <button *ngIf="isShowSendToTenant && asset?.isOnceSendToTenantAsset" class="common-button medium black mat-elevation-z0 rounded-corners me-1 mb-1 no-min-width" mat-button mat-raised-button (click)="openDrawer(asset.id)" [disabled]="isLoading">
        Resend Asset Details
    </button>
</div>

<!--Asset uploaded Drawer content-->
        <mat-drawer-container [hasBackdrop]="true">
            <!-- Drawer content -->
            <mat-drawer #drawer class="example-sidenav" mode="side" position="end">
                <section class="secondary-drawer-container">
                    <button class="drawer-close-btn mat-elevation-z0 m-0" (click)="closeDrawer()" mat-mini-fab
                        aria-label="Close">
                        <mat-icon>close</mat-icon>
                    </button>
                    <h5 class="drawer-title font-16">Request Tenants to Upload Assets</h5>
                    <h5 class="drawer-title font-14">Select Tenant Types</h5>
                </section>

                <div class="custom-scroller">
                    <div class="sms-checkbox mt-2">
                        <div class="mb-3">
                          <mat-checkbox [checked]="allTenantsComplete" [indeterminate]="someCompleteSendLink()" (change)="setAllSendLink($event.checked)" [disabled]="!sendTenatToAssetLinkEmail.isAIGenerated">
                            {{ sendSRequestTenantsToUploadAssets.name }}
                          </mat-checkbox>
                        </div>
                        <div>
                          <ul class="p-0 m-0 list-style-none">
                            <li *ngFor="let TeantSubtask of sendSRequestTenantsToUploadAssets.parties" class="mb-3">
                              <mat-checkbox [(ngModel)]="TeantSubtask.completed" (ngModelChange)="updateAllCompleteSendLink()"
                                [value]="TeantSubtask.value" [disabled]="!TeantSubtask.enabled">
                                {{ TeantSubtask.name }}
                              </mat-checkbox>
                            </li>
                          </ul>
                        </div>
                      </div>
                </div>

                <div class="inner-drawer-actions p-0">
                    <button class="common-button light-gray mat-elevation-z0 ms-2" mat-button mat-raised-button
                        (click)="closeDrawer()">
                        Cancel
                    </button>
                    <button [disabled]="!isAnyTenantSelected()" class="common-button black mat-elevation-z0 ms-2 me-0"
                        mat-button mat-raised-button (click)="inviteTenat()">
                        Send
                    </button>
                </div>
            </mat-drawer>
        </mat-drawer-container>
<!--Asset uploaded Drawer content-->
